import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Button, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import ReactTable from 'react-table';


import { getPayPeriodId } from '../selectors';
import { getApiServerUrl } from '../../configuration/selectors';
import { queryGetAllGuaranteedHoursGQL } from '../graphql/getGuaranteedHoursApi';
import linkWithCredentials from '../../../utils/linkWithCredentials';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

const propTypes = exact({
  payPeriodId: PropTypes.number,
  apiServerUrl: PropTypes.string.isRequired,

  loading: PropTypes.bool.isRequired,
  allGuaranteedHours: PropTypes.array.isRequired,
});


const GuaranteedHoursTable = (props) => {
  const { payPeriodId, apiServerUrl } = props;

  const { loading, allGuaranteedHours } = props;

  const noData = () => {
    if (loading) {
      return null;
    }
    return <div className="rt-noData">No rows found</div>;
  };

  const openUrl = () => {
    const urlCred = linkWithCredentials(`${apiServerUrl}//guaranteed_hours`);
    const csvUrl = `${urlCred}&pay_period_id=${payPeriodId}&with_headings=true`;
    downloadingFileAndUpdatingCredentials(csvUrl);
  };

  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          <Button
            onClick={openUrl}
            bsStyle="primary"
            className="pull-right"
          >
            Download Report
          </Button>
        </Col>
      </Row>
      <ReactTable
        data={allGuaranteedHours}
        loading={loading}
        NoDataComponent={noData}
        filterable
        columns={[
          {
            Header: 'Firstname',
            id: 'firstname',
            accessor: (e) => { return e.firstname; },
          },
          {
            Header: 'Lastname',
            id: 'lastname',
            accessor: (e) => { return e.lastname; },
          },
          {
            Header: 'Hours Short of 40 Per Week',
            id: 'hoursShortOfFourty',
            accessor: (e) => { return e.hoursShortOfFourty; },
          },
          {
            Header: 'Hours Actual Guaranteed Pay',
            id: 'hoursActualGuaranteedPay',
            accessor: (e) => { return e.hoursActualGuaranteedPay; },
          },
          {
            Header: 'Hours Saved',
            id: 'hoursSaved',
            accessor: (e) => { return e.hoursSaved; },
          },
        ]}
        defaultPageSize={20}
        className="-striped -highlight"
      />
    </React.Fragment>
  );
};


GuaranteedHoursTable.propTypes = propTypes;

const withNoPayPeriodId = branch(
  (props) => { return props.payPeriodId === null; },
  renderNothing,
);

const mapStateToProps = (state) => {
  return {
    payPeriodId: getPayPeriodId(state),
    apiServerUrl: getApiServerUrl(state),
  };
};

const withRedux = connect(mapStateToProps, {});

const enhance = compose(
  withRedux,
  withNoPayPeriodId,
  queryGetAllGuaranteedHoursGQL,
);


export default enhance(GuaranteedHoursTable);
